import { useState } from "react";

export type SelectorOption = {
  text: string;
  value: string;
};

export type ShowBy = "category_1" | "skill";

export type TopNOption = "25" | "50" | "100";

export const useSupplyDemandSection = () => {
  const [skillCategories, setSkillCategories] = useState<SelectorOption[]>([]);
  const [selectedSkills, setSelectedSkills] = useState<SelectorOption[]>([]);
  const [showBy, setShowBy] = useState<ShowBy>("category_1");
  const [bars, setBars] = useState<SelectorOption[]>([]);
  const [sortBy, setSortBy] = useState<string | null>(null);
  const [topN, setTopN] = useState<TopNOption>("25");

  return {
    skillCategories,
    setSkillCategories,
    selectedSkills,
    setSelectedSkills,
    showBy,
    setShowBy,
    bars,
    setBars,
    sortBy,
    setSortBy,
    topN,
    setTopN
  };
};
